import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  GetAllTags,
  CreateTag,
  UpdateTag,
  DeleteTag,
} from "../../services/tags";

const initialState = {
  tags: [],
  loading: false,
  error: null,
};

export const getAllTagsAsync = createAsyncThunk(
  "tags/getAllTagsAsync",
  async () => {
    return await GetAllTags();
  }
);

export const createTagAsync = createAsyncThunk(
  "tags/createTagAsync",
  async (payload) => {
    return await CreateTag(payload);
  }
);

export const updateTagAsync = createAsyncThunk(
  "tags/updateTagAsync",
  async ({ id, payload }) => {
    return await UpdateTag(payload, id);
  }
);

export const deleteTagAsync = createAsyncThunk(
  "tags/deleteTagAsync",
  async (id) => {
    await DeleteTag(id);
    return id;
  }
);

const tagSlice = createSlice({
  name: "tags",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllTagsAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllTagsAsync.fulfilled, (state, action) => {
        state.loading = false;
        state.tags = action.payload;
      })
      .addCase(getAllTagsAsync.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(createTagAsync.fulfilled, (state, action) => {
        state.tags.push(action.payload);
      })
      .addCase(updateTagAsync.fulfilled, (state, action) => {
        const index = state.tags.findIndex((tag) => tag.id === action.payload.id);
        if (index !== -1) {
          state.tags[index] = action.payload;
        }
      })
      .addCase(deleteTagAsync.fulfilled, (state, action) => {
        state.tags = state.tags.filter((tag) => tag.id !== action.payload);
      });
  },
});

export default tagSlice.reducer;
